import CertsSidePanelEntitlements from './CertsSidePanelEntitlements';

export default CertsSidePanelEntitlements;
